exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dg-btn--ok{color:#fff;background-color:#00a65a;border-color:#008d4c}.dg-btn--cancel{color:#fff;background-color:#dd4b39;border-color:#d73925}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12ac0dc2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Sections/Sections.vue
// module id = 1pzJ
// module chunks = 0